import { ProductStats } from './routes';

export const ProductStatsRoute = ProductStats;
